// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4c42d1a8e1d76a2e414f792bb525c640fd599e7a/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};